import { render } from "./UrlBlocker.vue?vue&type=template&id=4dc004aa"
import script from "./UrlBlocker.vue?vue&type=script&lang=js"
export * from "./UrlBlocker.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__